/** @file fillCuts: uploads cut slot images and fills their slots in one batch (one undo step). */
import { encodePng } from '@zilo/pose3d-image-io/png/encodePng';
import type { ArtActions } from '../artActions';
import type { BulkOutcome } from '../artTypes';
import type { CutPart } from './sheetTypes';

/**
 * PNG-encodes every cut (exact slot size, so no fit) and hands them to `fillMany` (one `slot.fill` batch); cuts that
 * clipped are named in a warning toast through `warn`, like a bulk upload's fit would.
 */
export async function fillCuts(actions: Pick<ArtActions, 'fillMany'>, cuts: readonly CutPart[], warn: (text: string) => void): Promise<BulkOutcome> {
  const items = await Promise.all(cuts.map(async (c) => ({ name: `${c.slot.replaceAll('/', '.')}.png`, slot: c.slot, png: await encodePng(c.image) })));
  const clipped = cuts.filter((c) => c.clipped).map((c) => c.slot);
  if (clipped.length > 0) warn(`Clipped to the slot size: ${clipped.join(', ')}`);
  return actions.fillMany(items);
}
